module.exports = ".modal-medium-personalized {\n  overflow-x: hidden !important; }\n\n.brd-none {\n  border: none !important; }\n\n.ml-90 {\n  margin-left: 90% !important; }\n\n.ng-select.custom /deep/ .ng-dropdown-panel /deep/ .ng-dropdown-panel-items {\n  max-height: 140px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/modify-document/modify-document.component.scss
// module id = ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/modify-document/modify-document.component.scss
// module chunks = main